"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var utils_1 = require("../utils");
var linkClick = function (event) {
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.LinkClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.LinkClick,
        link: {
            "linkTitle": event.eventData.link.linkTitle || consts_1.NOT_AVAILABLE,
            "linkModule": event.eventData.link.linkModule || consts_1.NOT_AVAILABLE,
            "targetURL": event.eventData.link.targetURL || consts_1.NOT_AVAILABLE,
        }
    };
    return (0, utils_1.checkDataLayerValueEmpty)(eventData);
};
exports.linkClick = linkClick;
